import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	searchFieldPlaceholder: {
		id: 'admin-pages-priority-schemes.filter.search-field-placeholder',
		defaultMessage: 'Filter by name',
		description: 'Placeholder for a filter by priority scheme name input field',
	},
});

export default messages;
